module.exports = __webpack_public_path__ + "static/media/WN.60cea0b5.png";